import PropTypes from 'prop-types';
import { PrimaryButton } from '@/components/button/button-component';
import Link from '@/components/link/link-component';
import Checkbox from '@/components/react-hook-form-inputs/checkbox/checkbox-component';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import {
  emailRegex,
  passwordRules,
  requiredValidationMessage,
} from '@/utils/validations';
import { MdLockOutline, MdOutlineEmail } from 'react-icons/md';
import styled from 'styled-components';
import Swal from 'sweetalert2';

/**
 * Complete Registration form
 * @param {object} props - Component props
 * @param {boolean} props.loading - Loading state
 * @returns {JSX.Element}
 */
const CompleteRegistrationForm = ({ loading }) => {
  const checkboxStyle = { padding: '24px 0 8px 0' };
  // TODO Remove this when we have the PDF from ETTX
  /**
   * @description This is a temporary Terms and Conditions (Waiting for the PDF from ETTX)
   */
  const handleClickTempSolution = () => {
    Swal.fire(
      'Lorem Ipsum',
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      'info',
    );
  };

  return (
    <Container>
      <Input
        disabled={loading}
        label="Email Address"
        placeholder="email"
        iconLeft={<MdOutlineEmail />}
        name="email"
        registerOptions={{
          validate: (value) => {
            let errorMessage = null;
            emailRegex.forEach((rule) => {
              if (!rule.pattern.test(value)) {
                errorMessage = rule.message;
              }
            });
            return errorMessage || true;
          },
        }}
      />
      <Input
        disabled={loading}
        iconLeft={<MdLockOutline />}
        label="Create New Password"
        placeholder="password"
        name="password"
        registerOptions={{
          validate: (value) => {
            let errorMessage = null;
            passwordRules.forEach((rule) => {
              if (!rule.pattern.test(value)) {
                errorMessage = rule.message;
              }
            });
            return errorMessage || true;
          },
        }}
        type="password"
      />
      <Input
        disabled={loading}
        iconLeft={<MdLockOutline />}
        label="Confirm New Password"
        placeholder="password"
        icon="password"
        name="confirmPassword"
        type="password"
        registerOptions={{
          required: requiredValidationMessage,
          validate: (value, getValues) =>
            value === getValues('password') || 'Passwords do not match',
        }}
      />
      <PrimaryButton
        buttonWidth="100%"
        buttonHeight="48px"
        type="submit"
        title="LOGIN"
        loading={loading}
      />
      <Checkbox
        style={checkboxStyle}
        type="checkbox"
        disabled={loading}
        name="termsAndConditions"
        label={
          <CheckboxText $disabled={loading} onClick={handleClickTempSolution}>
            {`I agree to the `}
            <Link to=".">Terms and Conditions</Link>
          </CheckboxText>
        }
        defaultValue
        registerOptions={{
          required: requiredValidationMessage,
        }}
      />
    </Container>
  );
};

CompleteRegistrationForm.propTypes = {
  loading: PropTypes.bool,
};

CompleteRegistrationForm.defaultProps = {
  loading: false,
};

const CheckboxText = styled.span`
  color: ${({ theme }) => theme.COLOR_BLACK};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

const Container = styled.div`
  display: flex;
  padding-top: 24px;
  min-width: 420px;
  display: flex;
  flex-direction: column;
`;

export default CompleteRegistrationForm;
